import script from "./JournalKept.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalKept.vue?vue&type=script&setup=true&lang=js"

import "./JournalKept.vue?vue&type=style&index=0&id=972fe294&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-972fe294"]])

export default __exports__